/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  DatePicker,
  Tabs,
  message,
  Typography,
} from 'antd';
import {
  CameraOutlined,
  EnvironmentOutlined,
  InfoCircleOutlined,
  PrinterOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import Direccion from 'components/Direccion';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import makeMessager from 'utils/complexFormsMessages';
import { makeGetOnFinish, makeOnChangeTabKey } from 'utils/tabsManagement';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission/index';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import {
  getInfraccion, getInfracciones, patchInfraccion, postInfracciones,
} from 'api/recaudacion/infracciones';
import { SLUG_PATTERN } from 'utils/patterns';
import NumericInput from 'components/NumericInput';
import { getEstadosDeInfracciones } from 'api/catalogos/estadosDeInfracciones';
import { useSelector } from 'react-redux';
import { getTiposDeInfractores } from 'api/catalogos/tiposDeInfractor';
import { getSectoresDeInfracciones } from 'api/recaudacion/sectoresDeInfraccion';
import { getPermisosDeTipoDePlaca } from 'api/catalogos/permisosDeTipoDePlacas';
import { getAgentesPoliciales } from 'api/catalogos/agentesPoliciales';
import { getUnidadesPoliciacas } from 'api/catalogos/unidadPoliciaca';
import { getTiposDeDocumentoDeGarantia } from 'api/recaudacion/tiposDeDocumentosDeGarantia';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { getCiudadano } from 'api/cuentaunicasir';
import { getContribuyente, getContribuyenteCaja } from 'api/empresas/contribuyentes';
import TableTipoDeConceptos from 'components/TableTiposConceptos';
import { getUsosDeMotocicletas } from 'api/catalogos';
import {
  getClasesDeServicios,
  getNotificacionesDeInfracciones,
  getRutasDeServiciosPublicos,
  getColorVehiculo,
} from 'api/recaudacion';
import { getLineaDeVehiculo } from 'api/recaudacion/lineasVehiculares';
import { getMarcaDeVehiculo } from 'api/recaudacion/marcasVehiculares';
import { getFundamentosLegales } from 'api/configuracion/fundamentosLegales';
import { getPadronesMap, retrievePadronesMap } from 'api/recaudacion/utils';
import { getTiposDeIdentificacion } from 'api/empresas';
import padronToString from 'utils/padronesToString';
import { getContenTypePorTipoDePadron } from 'utils/padrones';
import { getTipoDeVehiculo } from 'api/recaudacion/tiposDeVehiculos';
import EvidenciasDeInfracciones, { permissionConfig as permissionConfigEvidencias } from 'components/EvidenciasDeInfracciones';
import { postObtenerReporte } from 'api/reporteador';
import Previewer from 'components/Previewer';
import { capitalize, toUpper } from 'utils/normalizers';
import { getClasificacionDeLicencias } from 'api/catalogos/clasificacionDeLicencia';
import { getGruas } from 'api/catalogos/gruas';
import { getYardas } from 'api/catalogos/yardas';
import { getClasesDeVehiculos } from 'api/recaudacion/clasesVehiculos';
import ModalCancelarInfraccion from 'components/ModalCancelarInfraccion';
import { configPermmission as configPermissionConceptos } from './ConceptoDeInfracciones';

const { TabPane } = Tabs;
const baseURI = '/recaudacion/infracciones/';

export const permissionConfig = {
  title: 'Infracciones',
  permissionModel: 'infraccion',
  tabsModels: [configPermissionConceptos, permissionConfigEvidencias],
  catalogsModels: [
    'infraccion',
    'clasedeconceptodeinfraccion',
    'configuraciondeinfraccion',
    'estadodelainfraccion',
    'examenmedico',
    'grua',
    'permisodetipodeplaca',
    'sectordeinfraccion',
    'tipodedocumentodegarantia',
    'tipodeinfractor',
    'tipodeconceptodeinfraccion',
    'unidadpoliciaca',
    'yarda',
    'agentepolicial',
    'archivodeinfraccion',
  ],
};

export const defConfigDeInfraccion = {
  agente_usuario: true,
  aplica_a_padrones: true,
  aplica_aqc: true,
  aplica_calificar_estatus: true,
  aplica_folio_manual: true,
  aplica_fundamento_legal: true,
  aplica_infraccion_peatonal: true,
  aplica_infractor_manual: true,
  aplica_sectores: true,
  aplica_serie: true,
  aplican_acuses: true,
  aplican_advertencias: true,
};

const Infracciones = ({ permission }) => {
  const addressPermission = useMemo(() => getModelPermission('direccion'), []);
  const periodoFiscalSelected = useSelector(({ auth }) => auth.periodoFiscalSelected);
  const configDeInfraccion = useSelector(({ auth }) => auth.entidad);
  const padrones = useSelector(({ catalogs }) => catalogs.padrones)
    .filter((e) => [4, 16, 17].includes(e.id));
  const [form] = Form.useForm();
  const [formInfo] = Form.useForm();
  const [formInfractor] = Form.useForm();
  const [formDatosInfra] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [formAddress, setFormAddress] = useState();
  const [formAddressInfractor, setFormAddressInfractor] = useState();
  // const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [visibleBusquedaContribuyente, setVisibleBusquedaContribuyente] = useState(false);
  const [visibleBusquedaVehiculo, setVisibleBusquedaVehiculo] = useState(false);
  const [estadoDeLaInfraccion, setEstadoDeLaInfraccion] = useState([]);
  const generos = useSelector(({ catalogs }) => catalogs.generos);

  const [tipoDeInfractor, setTipoDeInfractor] = useState([]);
  const [permisoPlaca, setPermisoPlaca] = useState([]);
  const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [sectorDeInfraccion, setSectorDeInfraccion] = useState([]);
  const [agente, setAgente] = useState([]);
  const [vehiculoFound, setVehiculoFound] = useState([]);
  const [unidadPoliciaca, setUnidadPoliciaca] = useState([]);
  const [documentoDeGarantia, setDocumentoDeGarantia] = useState([]);
  const [claseDeServicio, setClaseDeServicio] = useState([]);
  const [rutas, setRutas] = useState([]);
  const [fundamentos, setFundamentos] = useState([]);
  const [notificaciones, setNotificaciones] = useState([]);
  const [tiposDeIdentificacion, setTiposDeIdentificacion] = useState([]);
  const [clasificacionDeLicencia, setClasificacionDeLicencia] = useState([]);
  const [gruas, setGruas] = useState([]);
  const [yardas, setYardas] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [claseDeVehiculo, setClaseDeVehiculo] = useState([]);
  const [usoDelVehiculo, setUsoDeVehiculo] = useState([]);
  const [soloConsulta, setSoloConsulta] = useState(false);
  const [padronSelected, setPadronSelected] = useState(null);
  const [searchParams, setSearchParams] = useState({});

  // previewer
  const [previewVisible, setPreviewVisible] = useState(false);
  const [base64, setBase64] = useState(null);

  const [infractorSelcted, setInfractorSelcted] = useState(1);
  const AQC = Form.useWatch('es_infractor_anonimo', formInfractor);
  const capturaDirecta = Form.useWatch('es_captura_directa_de_vehiculo', formInfo);
  const tipoDePadron = Form.useWatch('padron', formInfo);
  const tipoDeInfractorWatch = Form.useWatch('tipo_de_infractor', formInfractor);
  const padron_object_id = Form.useWatch('padron_object_id', formInfo);
  const infraccion_peatonal = Form.useWatch('infraccion_peatonal', formInfo);
  const clase_de_servicio = Form.useWatch('clase_de_servicio', formInfo);
  const permiso_de_tipo_de_placa = Form.useWatch('permiso_de_tipo_de_placa', formInfo);
  const tipo_identificacion = Form.useWatch('tipo_identificacion', formInfractor);
  const labelPadron = padrones.find((e) => e.id === tipoDePadron)?.descripcion;

  const basicKeys = ['general', 'info', 'infractor', 'datos'];
  const complexForms = [
    { key: 'direccion_de_infraccion', formInstance: formAddress, permission: addressPermission },
    { key: 'direccion_del_infractor', formInstance: formAddressInfractor, permission: addressPermission }];

  const fundamentoToString = (e) => `${e?.denominacion || ''} -  Artículo: ${e?.articulo || ''} - Fracción: ${e?.fraccion || ''} `;

  const disabledInfractor = () => {
    const _tipo_de_infractor = formInfractor.getFieldValue('tipo_de_infractor');
    const found = !!ciudadanoFound.length || !!contribuyenteFound.length;
    if (_tipo_de_infractor === 3) {
      if (found) {
        formInfractor.setFieldsValue({
          ciudadano: null,
          contribuyente: null,
          nombre: null,
          apellido_paterno: null,
          apellido_materno: null,
          genero: null,
          fecha_de_nacimiento: null,
          lugar_de_nacimiento: null,
          tipo_identificacion: null,
          tipo_licencia: null,
          numero_de_licencia: null,
          vigencia_licencia: null,
        });

        setCiudadanoFound([]);
        setContribuyenteFound([]);
      }
      return true;
    }
    return found;
  };

  useEffect(() => {
    const _tipo_de_infractor = formInfractor.getFieldValue('tipo_de_infractor');
    if (_tipo_de_infractor !== 3) {
      setDisabled(disabledInfractor());
    }
  }, [ciudadanoFound, contribuyenteFound]);

  useEffect(() => {
    setDisabled(disabledInfractor());
  }, [tipoDeInfractorWatch]);

  const fetchData = async (page = 1, params = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getInfracciones({
      ...(searchParams || {}),
      ...(params || {}),
      page,
      periodo_fiscal: periodoFiscalSelected?.id,
    });

    setData(_data);
    setLoading(false);
  };

  const showMsg = makeMessager(setCurrentTabKey, fetchData);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _estadoInfraccion,
        _tipoDeInfractor,
        _sector,
        _permisoPlaca,
        _agente,
        _unidades,
        _documento,
        _claseServicio,
        _rutas,
        _fundamentos,
        _notificaciones,
        _tiposDeIdentificacion,
        _clasificacionDeLicencia,
        _gruas,
        _yardas,
        _claseDeVehiculo,
        _usoDelVehiculo,
      ] = await Promise.all([
        getEstadosDeInfracciones(),
        getTiposDeInfractores(),
        getSectoresDeInfracciones(),
        getPermisosDeTipoDePlaca(),
        getAgentesPoliciales(),
        getUnidadesPoliciacas(),
        getTiposDeDocumentoDeGarantia(),
        getClasesDeServicios(),
        getRutasDeServiciosPublicos(),
        getFundamentosLegales({ es_para_infracciones: true }),
        getNotificacionesDeInfracciones(),
        getTiposDeIdentificacion(),
        getClasificacionDeLicencias(),
        getGruas(),
        getYardas(),
        getClasesDeVehiculos(),
        getUsosDeMotocicletas(),
      ]);
      if (mounted) {
        setTiposDeIdentificacion(_tiposDeIdentificacion);
        setEstadoDeLaInfraccion(_estadoInfraccion);
        setTipoDeInfractor(_tipoDeInfractor);
        setSectorDeInfraccion(_sector);
        setPermisoPlaca(_permisoPlaca);
        setAgente(_agente);
        setUnidadPoliciaca(_unidades);
        setDocumentoDeGarantia(_documento);
        setClaseDeServicio(_claseServicio);
        setRutas(_rutas);
        setFundamentos(_fundamentos.map((e) => ({
          ...e,
          denominacion: fundamentoToString(e),
        })));
        setNotificaciones(_notificaciones);
        setClasificacionDeLicencia(_clasificacionDeLicencia);
        setGruas(_gruas);
        setYardas(_yardas);
        setClaseDeVehiculo(_claseDeVehiculo.map((e) => ({
          ...e,
          descripcion: e.nombre || e.descripcion,
        })));
        setUsoDeVehiculo(_usoDelVehiculo);
        await fetchData();
        setLoading(false);
      }
    };

    if (permission.hasAllViewPermission) {
      fetchAll();
    }
    return () => { mounted = false; };
  }, []);

  const resetAndValidate = () => {
    setCiudadanoFound([]);
    formInfractor.resetFields(['q']);
    formInfractor.validateFields(['q']);
  };
  const resetAndValidateVehiculo = () => {
    setVehiculoFound([]);
    formInfo.resetFields(['q_vehiculo', 'padron_object_id']);
    formInfo.validateFields(['q_vehiculo', 'padron_object_id']);
  };

  const onCancel = () => {
    setVisible(false);
    setVisibleCancelar(false);
    setSoloConsulta(false);
    form.resetFields();
    formInfo.resetFields();
    formInfractor.resetFields();
    formDatosInfra.resetFields();
    setSelectedRowKeys([]);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    setCurrentTabKey('general');
    setInfractorSelcted(1);
  };

  const extractDireccion = (values, type) => {
    if (values?.[type]?.direcciones && !values.fecha_de_nacimiento) {
      return `${values?.[type]?.direcciones?.codigo_postal?.municipio?.nom_mun}, ${values?.[type]?.direcciones?.codigo_postal?.municipio?.estado?.nombre_de_AGEE}`;
    }
    return values.lugar_de_nacimiento || '';
  };

  const concatNames = (values) => `${values?.nombre} ${values?.apellido_paterno
    || ''} ${values?.apellido_materno
    || ''}`;

  const fetchCiudadano = async (id, match) => {
    setLoading(true);
    if (id) {
      const _ciudadano = await getCiudadano(id?.id);
      if (_ciudadano) {
        formInfractor.setFieldsValue({
          ..._ciudadano,
          ciudadano: _ciudadano.id,
          genero: _ciudadano.genero,
          nombre: _ciudadano.nombre,
          apellido_paterno: _ciudadano.apellido_paterno,
          apellido_materno: _ciudadano.apellido_materno || '',
          fecha_de_nacimiento: _ciudadano.fecha_de_nacimiento || '',
          lugar_de_nacimiento: extractDireccion(match || _ciudadano, 'ciudadano'),
        });
        setCiudadanoFound([_ciudadano]);
        if (!capturaDirecta) {
          formInfo.setFieldsValue({
            nombre_completo_propietario: 'MATCOSDE 4',
          });
        }
      } else {
        message.info('No se encontró ciudadano');
      }
    }
    setLoading(false);
  };

  const fetchContribuyente = async (id, match) => {
    setLoading(true);
    if (id) {
      const _contribuyente = await getContribuyente(id?.id || id);
      if (_contribuyente) {
        setContribuyenteFound([_contribuyente]);
        formInfractor.setFieldsValue({
          ..._contribuyente,
          contribuyente: _contribuyente.id,
          genero: _contribuyente.genero,
          nombre: _contribuyente.nombre,
          apellido_paterno: _contribuyente.apellido_paterno,
          apellido_materno: _contribuyente.apellido_materno || '',
          fecha_de_nacimiento: _contribuyente.fecha_de_nacimiento || '',
          lugar_de_nacimiento: extractDireccion(match || _contribuyente, 'contribuyente'),
          numero_de_licencia: match?.numero_de_licencia || _contribuyente?.licencia,
          numero_identificacion:
            match?.numero_identificacion || _contribuyente?.numero_identificacion,
        });
        if (!capturaDirecta) {
          formInfo.setFieldsValue({
            nombre_completo_propietario: match?.nombre_completo_propietario
            || _contribuyente?.nombre_completo,
          });
        }
        setDisabled(true);
      } else {
        message.info('No se encontró el Contribuyente');
      }
    }
    setLoading(false);
  };

  const searchColorVehiculo = async (value) => {
    const _color = await getColorVehiculo(value);
    if (_color) {
      formInfo.setFieldsValue({
        color_del_vehiculo: _color?.descripcion,
      });
    }
  };

  const fetchVehiculo = async (_vehi, _tipoDePadron = tipoDePadron) => {
    setLoading(true);
    if (_vehi) {
      const _vehiculo = await retrievePadronesMap[_tipoDePadron](_vehi?.id || _vehi);
      if (_vehiculo) {
        const tipoDeVehiculos = _vehiculo?.tipo_de_vehiculo || _vehiculo?.tipo_de_motocicleta
        || _vehiculo?.tipo;
        const linea = typeof _vehiculo?.linea === 'string'
          ? _vehiculo?.linea : await getLineaDeVehiculo(_vehiculo?.linea);
        const marca = await getMarcaDeVehiculo(linea?.marca || _vehiculo.marca);
        const tipo = await getTipoDeVehiculo(tipoDeVehiculos);
        const propietario = _vehiculo?.es_propietario_ciudadano
          ? await getCiudadano(_vehiculo?.propietario || _vehiculo?.propietario?.id)
          // eslint-disable-next-line max-len
          : await getContribuyente(_vehiculo?.contribuyente_propietario || _vehiculo?.contribuyente_propietario?.id);
        if (propietario) {
          _vehiculo.nombre_completo_propietario = propietario?.nombre_completo;
        }
        searchColorVehiculo(_vehiculo?.color_del_vehiculo || _vehiculo?.color_secundario);
        formInfo.setFieldsValue({
          ..._vehiculo,
          padron_object_id: _vehiculo?.id,
          numero_de_placa: _vehiculo?.numero_de_placa_vigente || _vehiculo?.placa,
          numero_de_serie: _vehiculo?.numero_de_identificacion_vehicular || _vehiculo?.serie,
          linea_del_vehiculo: typeof _vehiculo?.linea === 'string' ? linea : linea?.nombre,
          marca_del_vehiculo: marca?.descripcion || marca?.nombre,
          anio_de_modelo_vehicular: _vehiculo?.modelo,
          clase_de_vehiculo: _vehiculo?.clase_de_vehiculo,
          tipo_del_vehiculo: tipo?.descripcion,
          clase_de_servicio: _vehiculo?.clase_de_servicio,
          nombre_completo_propietario: propietario?.nombre_completo || `${propietario?.nombre} ${propietario?.apellido_paterno
            || ''}`,
        });
        setVehiculoFound([_vehiculo]);
      } else {
        message.info(`No se encontró el ${labelPadron} correspondiente`);
      }
    }
    setLoading(false);
  };

  const onClickEdit = async (infraccionID) => {
    try {
      setLoading(true);
      const key = selectedRowKeys[0] || infraccionID || infraccionID?.id;
      const match = await getInfraccion(key);
      if (match) {
        form.setFieldsValue(match);
        formInfo.setFieldsValue(match);
        formInfractor.setFieldsValue(match);
        formDatosInfra.setFieldsValue(match);
        // Inyeccion de datos para casos especiales o de registros ligados a otro ep/tabla
        if (match.tipo_de_infractor) {
          setInfractorSelcted(match.tipo_de_infractor);
        }
        if (match.ciudadano) {
          await fetchCiudadano(match.ciudadano || match.ciudadano?.id, match);
        }
        if (match.contribuyente) {
          await fetchContribuyente(match.contribuyente || match.contribuyente?.id, match);
        }
        if (match.padron_object_id) {
          await fetchVehiculo(match.padron_object_id, match.padron);
        }

        if (match?.genero) {
          formInfractor.setFieldsValue({
            genero: match?.genero,
          });
        }

        if (match?.fecha_de_nacimiento) {
          formInfractor.setFieldsValue({
            fecha_de_nacimiento: match?.fecha_de_nacimiento,
          });
        }

        if (match?.tipo_del_vehiculo) {
          formInfo.setFieldsValue({
            tipo_del_vehiculo: match?.tipo_del_vehiculo,
          });
        }

        if (match?.tipo_de_vehiculo) {
          formInfo.setFieldsValue({
            tipo_de_vehiculo: match?.tipo_de_vehiculo,
          });
        }

        if (match?.uso_del_vehiculo) {
          formInfo.setFieldsValue({
            uso_del_vehiculo: match?.uso_del_vehiculo?.id,
          });
        }

        if (match?.clase_de_vehiculo) {
          formInfo.setFieldsValue({
            clase_de_vehiculo: match?.clase_de_vehiculo?.id,
          });
        }

        if (match?.numero_economico) {
          formInfo.setFieldsValue({
            numero_economico: match?.numero_economico,
          });
        }

        if (match?.tipo_identificacion) {
          formInfractor.setFieldsValue({
            tipo_identificacion: match?.tipo_identificacion,
          });
        }
      }
      setLoading(false);
      setVisible(true);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formInfo.validateFields();
      await formInfractor.validateFields();
      await formDatosInfra.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formInfo.getFieldsValue(),
        ...formInfractor.getFieldsValue(),
        ...formDatosInfra.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      values.hora_cierre_licencia = values?.hora_cierre_licencia
        ? values?.hora_cierre_licencia.format('YYYY-MM-DDTHH:mm') : null;
      values.momento_de_infraccion = values?.momento_de_infraccion
        ? values?.momento_de_infraccion.format('YYYY-MM-DDTHH:mm') : null;
      values.periodo_fiscal = periodoFiscalSelected?.id;
      values.clase_de_vehiculo = typeof values.clase_de_vehiculo === 'string' ? claseDeVehiculo.find((e) => e.descripcion === formInfo.getFieldValue('clase_de_vehiculo'))?.id : values.clase_de_vehiculo;
      values.nombre_completo = AQC ? 'A quien corresponda' : concatNames(values);
      if (padron_object_id) {
        values.padron_content_type = getContenTypePorTipoDePadron(values.padron);
      }
      const _data = await (key ? patchInfraccion(key, values) : postInfracciones(values));
      if (_data) {
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
          }
          await onClickEdit(_data.id);
        } else {
          onCancel();
        }
        await fetchData();
        setLoading(false);
        return _data;
      }
      setLoading(false);
      return true;
    } catch (err) {
      onError(err, setLoading, [form, formInfo, formInfractor, formDatosInfra], setCurrentTabKey);
      return false;
    }
  };

  // const deleteItem = async () => {
  //   setLoading(true);
  //   const [key] = selectedRowKeys;
  //   if (key) {
  //     const deleted = await deleteInfraccion(key);
  //     if (deleted) {
  //       // setVisibleAlert(false);
  //       onCancel();
  //       await fetchData();
  //     }
  //   }
  //   setLoading(false);
  // };

  const handleOnRowClick = (record) => {
    const estado = estadoDeLaInfraccion.find(
      (e) => e.id === record?.estado_de_la_infraccion,
    )?.descripcion;

    if (estado === 'SALDADA' || estado === 'CANCELADA') {
      setSoloConsulta(true);
    } else {
      setSoloConsulta(false);
    }
    setPadronSelected(record.padron);
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => { onCancel(); setVisible(true); };
  const onClickCancel = () => {
    if (soloConsulta) {
      message.warn('Registro Saldado o Cancelado. No se puede Cancelar');
    } else {
      setVisibleCancelar(true);
    }
  };
  const handleSearch = async () => {
    try {
      setLoading(true);
      await formSearch.validateFields();
      const raw = formSearch.getFieldsValue();
      const params = {
        ...raw,
        fecha_inicio: raw.fecha_inicio ? raw.fecha_inicio.format('YYYY-MM-DD HH:mm:ss') : undefined,
        fecha_fin: raw.fecha_fin ? raw.fecha_fin.format('YYYY-MM-DD HH:mm:ss') : undefined,
      };

      const hasAny = Object.values(params).some((v) => v !== undefined && v !== null && v !== '');
      if (!hasAny) {
        message.warn('Debe ingresar al menos un campo.');
        return;
      }

      setSearchParams(params);
      setCurrentPage(1);
      await fetchData(1, params);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const wipe = () => {
    formSearch.resetFields();
    setSearchParams({});
    fetchData(1, {});
    setData({ results: [] });
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Serie',
      dataIndex: 'numero_de_serie',
      key: 'numero_de_serie',
      width: 200,
    },
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 200,
    },
    // {
    //   titleText: 'Fecha de Infracción',
    //   dataIndex: 'momento_de_infraccion',
    //   key: 'momento_de_infraccion',
    //   width: 200,
    //   render: (val) => (val?.format(DATETIME_FRONTEND_FORMAT)),
    // },
    {
      titleText: 'Placa',
      dataIndex: 'numero_de_placa',
      key: 'numero_de_placa',
      width: 200,
    },
    {
      titleText: 'Nombre de Infractor',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
      render: (val, record) => {
        const { nombre, apellido_paterno, apellido_materno } = record;
        const nombreCompleto = `${nombre} ${apellido_paterno || ''} ${apellido_materno || ''}`;
        return (
          <span>
            {
              nombreCompleto.includes('null') ? 'A quien corresponda' : nombreCompleto
            }
          </span>
        );
      },
      width: 300,
    },
    {
      titleText: 'Número de Licencia',
      dataIndex: 'numero_de_licencia',
      key: 'numero_de_licencia',
      width: 200,
    },
    {
      titleText: 'Estado de la Infracción',
      dataIndex: 'estado_de_la_infraccion',
      key: 'estado_de_la_infraccion',
      width: 200,
      catalog: {
        cat: estadoDeLaInfraccion,
      },
    },
  ];

  const canalOptions = [
    {
      Descriptions: 'Aplicación móvil',
      value: 'APP',
    },
    {
      Descriptions: 'Sitio web',
      value: 'WEB',
    },
  ];

  const rules = {
    required: [
      { required: true },
    ],
    slug: [
      {
        required: true,
        pattern: SLUG_PATTERN,
        message: 'Ingrese un valor correcto',
      },
    ],
  };

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const getOnFinish = makeGetOnFinish(basicKeys, complexForms, currentTabKey, onFinish);

  const searchCiudadano = async () => {
    try {
      setLoading(true);
      await formInfractor.validateFields(['q']);
      const { q } = formInfractor.getFieldsValue(['q']);
      if (q) {
        const _ciudadanos = await getCiudadanoCaja({ q });
        if (_ciudadanos.results.length) {
          const [selected] = _ciudadanos.results;
          formInfractor.setFieldsValue({
            ...selected,
            ciudadano: selected.id,
            genero: selected.genero,
            nombre: selected.nombre,
            apellido_paterno: selected.apellido_paterno,
            apellido_materno: selected.apellido_materno || '',
            fecha_de_nacimiento: selected.fecha_de_nacimiento || '',
            lugar_de_nacimiento: selected.direccion
              ? `${selected.direccion.codigo_postal?.municipio?.nom_mun}, ${selected.direccion.codigo_postal?.municipio?.estado?.nombre_de_AGEE}`
              : null,
          });
          setCiudadanoFound([selected]);
          if (!capturaDirecta) {
            formInfo.setFieldsValue({
              nombre_completo_propietario: 'MATCOSDE',
            });
          }
        } else if (!_ciudadanos.results.length) {
          message.info('No se encontró ciudadano');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const searchVehiculo = async () => {
    try {
      setLoading(true);
      await formInfo.validateFields(['q_vehiculo']);
      const { q_vehiculo } = formInfo.getFieldsValue();
      if (q_vehiculo) {
        const _vehiculos = await getPadronesMap[tipoDePadron]({ q: q_vehiculo });
        if (_vehiculos.results?.length || _vehiculos.length) {
          const [selected] = _vehiculos.results || _vehiculos;
          const linea = typeof selected?.linea === 'string'
            ? selected?.linea : await getLineaDeVehiculo(selected?.linea);
          const marca = await getMarcaDeVehiculo(linea?.marca || selected.marca);
          const tipo = await getMarcaDeVehiculo(selected?.tipo_de_vehiculo);
          const propietario = selected?.es_propietario_ciudadano
            ? await getCiudadano(selected?.propietario?.id || selected?.propietario)
            // eslint-disable-next-line max-len
            : await getContribuyente(selected?.contribuyente_propietario?.id || selected?.contribuyente_propietario);
          if (propietario) {
            selected.nombre_completo_propietario = propietario?.nombre_completo;
          }
          searchColorVehiculo(selected?.color_del_vehiculo || selected?.color_secundario);
          formInfo.setFieldsValue({
            ...selected,
            padron_object_id: selected?.id,
            numero_de_placa: selected?.numero_de_placa_vigente,
            numero_de_serie: selected?.numero_de_identificacion_vehicular,
            linea_del_vehiculo: typeof selected?.linea === 'string' ? linea : linea?.nombre,
            marca_del_vehiculo: marca?.descripcion || marca?.nombre,
            anio_de_modelo_vehicular: selected?.modelo,
            clase_de_vehiculo: selected?.clase_de_vehiculo,
            clase_de_servicio: selected?.clase_de_servicio,
            nombre_completo_propietario: propietario?.nombre_completo || `${propietario?.nombre} ${propietario?.apellido_paterno
              || ''}`,
            tipo_del_vehiculo: tipo?.descripcion,
          });
          setVehiculoFound([selected]);
        } else if (!_vehiculos.results.length) {
          message.info(`No se encontró ${labelPadron}`);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const resetAndValidateContribuyente = () => {
    setContribuyenteFound([]);
    formInfractor.resetFields(['q_contribuyente']);
    formInfractor.validateFields(['q_contribuyente']);
  };

  const captureOptions = [
    {
      descripcion: 'Asignación de vehículos existentes',
      value: false,
    },
    {
      descripcion: 'Captura directa',
      value: true,
    },
  ];

  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await formInfractor.validateFields(['q']);
      const { q } = formInfractor.getFieldsValue(['q']);
      if (q) {
        const _contribuyente = await getContribuyenteCaja({ q });
        if (_contribuyente?.results?.length === 1) {
          const [selected] = _contribuyente.results;
          formInfractor.setFieldsValue({
            ...selected,
            contribuyente: selected?.id,
            genero: selected?.genero,
            nombre: selected?.nombre,
            apellido_paterno: selected?.apellido_paterno,
            apellido_materno: selected?.apellido_materno || '',
            fecha_de_nacimiento: selected?.fecha_de_nacimiento || '',
            lugar_de_nacimiento: extractDireccion(selected),
          });
          setContribuyenteFound([selected]);
          if (!capturaDirecta) {
            formInfo.setFieldsValue({
              nombre_completo_propietario: selected?.nombre_completo,
              licencia: selected?.licencia,
              numero_identificacion: selected?.numero_identificacion,
            });
          }
        } else if (_contribuyente.results.length > 1) {
          setVisibleBusquedaPadrones(true);
        } if (!_contribuyente.results.length) {
          message.info('No se encontró Contribuyente');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleImprimirActaDeInfraccion = async () => {
    const [key] = selectedRowKeys;
    if (!key) {
      message.info('Seleccione un registro');
      return;
    }
    setLoading(true);

    const values = {
      ID: 1033,
      Parametros: [
        {
          Nombre: 'infraccion',
          Valor: parseInt(key, 10),
          TipoParametro: 'Texto',
        },
      ],
    };

    const reporte = await postObtenerReporte(values);
    if (reporte) {
      setBase64(reporte);
      setPreviewVisible(true);
    }
    setLoading(false);
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible
          ? (
            <>
              <Form
                layout="vertical"
                form={formSearch}
                scrollToFirstError
                onFinish={() => handleSearch()}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Canal de levantamiento"
                      name="canal_levantamiento"
                      normalize={capitalize}
                    >
                      <Select
                        dataSource={canalOptions}
                        valueProp="value"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Fecha inicial"
                      name="fecha_inicio"
                      normalize={capitalize}
                    >
                      <DatePicker
                        showTime
                        format={`${DATE_FRONTEND_FORMAT} HH:mm`}
                        disabledDate={(current) => current && current > new Date()}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Fecha final"
                      name="fecha_fin"
                      normalize={capitalize}
                    >
                      <DatePicker
                        showTime
                        format={`${DATE_FRONTEND_FORMAT} HH:mm`}
                        disabledDate={(current) => current && current > new Date()}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Estado de la infraccion"
                      name="estado_de_la_infraccion"
                      normalize={capitalize}
                    >
                      <Select dataSource={estadoDeLaInfraccion} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={6}>
                    <Button
                      onClick={handleSearch}
                      block
                      style={{ marginTop: 21 }}
                    >
                      <SearchOutlined />
                      <Typography.Text>
                        Buscar
                      </Typography.Text>
                    </Button>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Button
                      onClick={wipe}
                      block
                      style={{ marginTop: 21 }}
                    >
                      <DeleteOutlined />
                      <Typography.Text>
                        Limpiar Busqueda
                      </Typography.Text>
                    </Button>
                  </Col>
                </Row>
              </Form>
              <Table
                cols={columns}
                mobileColumns={[columns[0], columns[1]]}
                data={data.results || []}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                controls={{
                  onClickAdd,
                  onClickDelete: () => onClickCancel(),
                  onClickEdit,
                }}
                deleteText="Cancelar"
                customActions={[
                  {
                    text: 'Acta de Infracción',
                    onClick: () => handleImprimirActaDeInfraccion(),
                    icon: <PrinterOutlined />,
                    disabledBySelection: true,
                  },
                ]}
                rowKey="id"
                baseURI={baseURI}
                permission={permission}
                pagination={false}
                paginationCallback={fetchData}
                count={data.count}
                currentPage={currentPage}
              />
            </>
          ) : (
            <Col span={24} style={{ height: '100%' }}>
              <Card
                className="form-container"
                title={`
                  ${selectedRowKeys.length
                  ? `Editando Clave: ${form.getFieldValue('clave')} - Folio: ${form.getFieldValue('folio')}`
                  : 'Agregar Infracción'}`}
                extra={(
                  <FormSubmitControls
                    onFinish={getOnFinish()}
                    onCancel={onCancel}
                    allowCancel
                    allowSaveAndContinue
                    onCancelText="Regresar"
                    permission={permission}
                  />
                )}
                bordered={false}
              >
                <Tabs
                  onChange={onChangeTabKey}
                  activeKey={currentTabKey}
                  type="card"
                >
                  <TabPane
                    tab={(
                      <span>
                        <InfoCircleOutlined />
                        Informacion General
                      </span>
                    )}
                    key="general"
                    forceRender
                  >
                    <Form
                      name="general"
                      layout="vertical"
                      form={form}
                      onFinish={() => onFinish()}
                      scrollToFirstError
                      initialValues={{
                        estado_de_la_infraccion: configDeInfraccion?.estados_de_la_infraccion,
                        infraccion_de_advertencia: false,
                        tipo_identificacion: 1,
                      }}
                    >
                      <Row gutter={10}>
                        {!!selectedRowKeys.length && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              name="clave"
                              label="Clave"
                              rules={rules.required}
                              hasFeedback
                              normalize={toUpper}
                            >
                              <Input allowClear disabled={soloConsulta} />
                            </Form.Item>
                          </Col>
                        )}
                        {configDeInfraccion.aplica_folio_manual && (
                          <Col xs={24} sm={24} md={selectedRowKeys.length ? 8 : 12}>
                            <Form.Item
                              name="folio"
                              label="Folio"
                              hasFeedback
                              rules={rules.slug}
                              normalize={toUpper}
                            >
                              <Input allowClear disabled={soloConsulta} maxLength={50} />
                            </Form.Item>
                          </Col>
                        )}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Estado de la Infracción"
                            name="estado_de_la_infraccion"
                            rules={rules.required}
                          >
                            <Select
                              disabled={!configDeInfraccion.aplica_calificar_estatus
                                || soloConsulta}
                              dataSource={estadoDeLaInfraccion}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="momento_de_infraccion"
                            label="Fecha y hora de la Infracción"
                            rules={rules.required}
                          >
                            <DatePicker
                              showTime
                              disabled={soloConsulta}
                              format={`${DATE_FRONTEND_FORMAT} HH:mm`}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="hora_cierre_licencia"
                            label="Hora de cierre"
                            rules={rules.required}
                          >
                            <DatePicker
                              showTime
                              disabled={soloConsulta}
                              format={`${DATE_FRONTEND_FORMAT} HH:mm`}
                            />
                          </Form.Item>
                        </Col>
                        {configDeInfraccion.aplican_advertencias && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              label="¿Es Advertencia?"
                              name="infraccion_de_advertencia"
                              rules={rules.required}
                            >
                              <Select disabled={soloConsulta} trueFalse />
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                  </TabPane>
                  <TabPane
                    tab={(
                      <span>
                        <InfoCircleOutlined />
                        Información Del Infractor
                      </span>
                    )}
                    key="infractor"
                    forceRender
                  >
                    <Form
                      name="infractor"
                      layout="vertical"
                      form={formInfractor}
                      onFinish={() => onFinish()}
                      scrollToFirstError
                      initialValues={{
                        es_infractor_anonimo: false,
                        tipo_de_infractor: 1,
                      }}
                    >
                      <Row gutter={10}>
                        {configDeInfraccion.aplica_aqc && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              label="¿A quien corresponda?"
                              name="es_infractor_anonimo"
                            >
                              <Select disabled={soloConsulta} trueFalse />
                            </Form.Item>
                          </Col>
                        )}
                        {!AQC && (
                          <>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Tipo de Infractor"
                                name="tipo_de_infractor"
                                rules={rules.required}
                              >
                                <Select
                                  disabled={soloConsulta}
                                  dataSource={tipoDeInfractor}
                                  onChange={() => {
                                    setInfractorSelcted(formInfractor.getFieldValue('tipo_de_infractor'));
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            {infractorSelcted === 1 && (
                              <InputSearchPro
                                label="Ciudadano"
                                name="q"
                                onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                                breakPoints={{
                                  xs: 24,
                                  sm: 24,
                                  md: 8,
                                }}
                                inputProps={{
                                  onPressEnter: () => searchCiudadano(),
                                  onChange: ({ target: { value } }) => {
                                    if (!value) {
                                      resetAndValidate();
                                    }
                                  },
                                }}
                                resultProps={{
                                  name: 'ciudadano',
                                  label: 'ciudadano',
                                  dataSource: ciudadanoFound,
                                  labelProp: 'nombre_completo',
                                  onClear: resetAndValidate,
                                  rules: rules.required,
                                  breakPoints: {
                                    xs: 24,
                                    sm: 24,
                                    md: 8,
                                  },
                                }}
                              />
                            )}
                            {infractorSelcted === 2 && (
                              <InputSearchPro
                                label="Contribuyente"
                                name="q_contribuyente"
                                onClickAdvanced={() => setVisibleBusquedaContribuyente(true)}
                                breakPoints={{
                                  xs: 24,
                                  sm: 24,
                                  md: 8,
                                }}
                                inputProps={{
                                  onPressEnter: () => searchContribuyente(),
                                  onChange: ({ target: { value } }) => {
                                    if (!value) {
                                      resetAndValidateContribuyente();
                                    }
                                  },
                                }}
                                resultProps={{
                                  label: 'Contribuyente',
                                  name: 'contribuyente',
                                  dataSource: contribuyenteFound,
                                  labelProp: 'nombre_completo',
                                  onClear: resetAndValidateContribuyente,
                                  rules: rules.required,
                                  breakPoints: {
                                    xs: 24,
                                    sm: 24,
                                    md: 8,
                                  },
                                }}
                              />
                            )}
                            { disabled && (
                              <>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    name="nombre"
                                    label="Nombre"
                                  >
                                    <Input
                                      allowClear
                                      disabled={(!configDeInfraccion.aplica_infractor_manual
                                      || ciudadanoFound.length || contribuyenteFound.length)
                                    || soloConsulta}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    name="apellido_paterno"
                                    label="Apellido Paterno"
                                  >
                                    <Input
                                      disabled={(!configDeInfraccion.aplica_infractor_manual
                                      || ciudadanoFound.length || contribuyenteFound.length)
                                      || soloConsulta}
                                      allowClear
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    name="apellido_materno"
                                    label="Apellido Materno"
                                  >
                                    <Input
                                      disabled={(!configDeInfraccion.aplica_infractor_manual
                                        || ciudadanoFound.length || contribuyenteFound.length)
                                        || soloConsulta}
                                      allowClear
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    name="genero"
                                    label="Género"
                                  >
                                    <Select disabled={soloConsulta} dataSource={generos} />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    name="fecha_de_nacimiento"
                                    label="Fecha de Nacimiento"
                                  >
                                    <DatePicker
                                      placeholder=""
                                      format={DATE_FRONTEND_FORMAT}
                                      disabled={soloConsulta}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={selectedRowKeys.length ? 12 : 8}>
                                  <Form.Item
                                    name="lugar_de_nacimiento"
                                    label="Lugar de Nacimiento"
                                  >
                                    <Input
                                      allowClear
                                      disabled={soloConsulta}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    name="tipo_identificacion"
                                    label="Tipo De Identificación"
                                  >
                                    <Select
                                      dataSource={tiposDeIdentificacion}
                                      allowClear={false}
                                      disabled={soloConsulta}
                                    />
                                  </Form.Item>
                                </Col>
                                {
                                  tipo_identificacion === 1 && (
                                    <>
                                      <Col xs={24} sm={24} md={8}>
                                        <Form.Item
                                          name="clasificacion_de_licencia"
                                          label="Clasificación de Licencia"
                                        >
                                          <Select
                                            dataSource={clasificacionDeLicencia}
                                            allowClear={false}
                                            disabled={soloConsulta}
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col xs={24} sm={24} md={8}>
                                        <Form.Item
                                          name="vigencia_licencia"
                                          label={`Vigencia ${tiposDeIdentificacion
                                            .find((e) => e.id === 1)?.descripcion}`}
                                        >
                                          <DatePicker
                                            placeholder=""
                                            format={DATE_FRONTEND_FORMAT}
                                            disabled={soloConsulta}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </>
                                  )
                                }
                                { tipo_identificacion && (
                                  <>
                                    <Col xs={24} sm={24} md={8}>
                                      <Form.Item
                                        name="numero_de_licencia"
                                        label={tiposDeIdentificacion
                                          .find((e) => e.id === tipo_identificacion)?.descripcion}
                                      >
                                        <Input
                                          allowClear
                                          disabled={soloConsulta}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="comentarios_sobre_el_infractor"
                            label="Comentarios Sobre el Infractor"
                            normalize={toUpper}
                          >
                            <Input.TextArea
                              autoSize={{ minRows: 3, maxRows: 3 }}
                              allowClear
                              disabled={soloConsulta}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  {addressPermission?.view && (
                    <TabPane
                      tab={(
                        <>
                          <EnvironmentOutlined />
                          Dirección de Infractor
                        </>
                      )}
                      key="direccion_del_infractor"
                      forceRender={!!selectedRowKeys?.length}
                      disabled={!selectedRowKeys.length}
                    >
                      <Direccion
                        mutable={!soloConsulta}
                        currentURI={baseURI}
                        parentID={selectedRowKeys[0]}
                        setLoading={setLoading}
                        setFormAddress={setFormAddressInfractor}
                        setCurrentTabKey={setCurrentTabKey}
                        addressPropName="direccion_del_infractor"
                        callback={(values, _continue) => {
                          if (!_continue) {
                            onCancel();
                          } else {
                            const [key] = selectedRowKeys;
                            const clone = [...data?.results];
                            const mappedData = clone.map((e) => (e.id === key
                              ? ({ ...e, direccion_del_infractor: values?.id }) : e));
                            setData(mappedData);
                          }
                        }}
                        permission={addressPermission}
                      />
                    </TabPane>
                  )}
                  <TabPane
                    tab={(
                      <span>
                        <InfoCircleOutlined />
                        Datos del Vehículo
                      </span>
                  )}
                    key="info"
                    forceRender
                  >
                    <Form
                      name="info"
                      layout="vertical"
                      form={formInfo}
                      onFinish={() => onFinish()}
                      initialValues={{
                        permiso_de_tipo_de_placa: 1,
                        infraccion_peatonal: false,
                        es_captura_directa_de_vehiculo: configDeInfraccion.aplica_a_padrones,
                        padron: 4,
                      }}
                      scrollToFirstError
                    >
                      <Row gutter={10}>
                        {configDeInfraccion.aplica_infraccion_peatonal && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              label="¿Infracción Peatonal?"
                              name="infraccion_peatonal"
                            >
                              <Select disabled={soloConsulta} trueFalse />
                            </Form.Item>
                          </Col>
                        )}
                        {!infraccion_peatonal && (
                          <>
                            {configDeInfraccion.aplica_a_padrones && (
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  label="Tipo de captura"
                                  name="es_captura_directa_de_vehiculo"
                                >
                                  <Select
                                    // onChange={(val) => (val ? setVehiculoFound([]) : null)}
                                    dataSource={captureOptions}
                                    disabled={soloConsulta}
                                    valueProp="value"
                                    onChange={(val) => {
                                      if (val) {
                                        setVehiculoFound([]);
                                        formInfo.resetFields();
                                        if (!capturaDirecta) {
                                          formInfo.setFieldsValue({ padron: 4 });
                                        }
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            )}
                            { capturaDirecta !== 1 ? (
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  label="Tipo de Vehículos"
                                  name="clase_de_vehiculo"
                                  normalize={toUpper}
                                >
                                  <Select
                                    allowClear
                                    disabled={soloConsulta}
                                    valueProp="id"
                                    dataSource={claseDeVehiculo}
                                    onChange={(val) => {
                                      claseDeVehiculo.forEach((e) => {
                                        if (e.id === val) {
                                          formInfo.setFieldsValue({
                                            clase_de_vehiculo: e.descripcion,
                                          });
                                        }
                                      });
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            ) : (
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  label="Tipo de Vehículos"
                                  name="padron"
                                >
                                  <Select
                                    dataSource={padrones}
                                    disabled={!!padron_object_id || soloConsulta}
                                    allowClear={false}
                                  />
                                </Form.Item>
                              </Col>
                            )}
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Uso del Vehículo"
                                name="uso_del_vehiculo"
                              >
                                <Select
                                  dataSource={usoDelVehiculo}
                                  disabled={!capturaDirecta || soloConsulta}
                                />
                              </Form.Item>
                            </Col>
                            { configDeInfraccion.aplica_a_padrones && !capturaDirecta && (
                              <InputSearchPro
                                label={labelPadron}
                                name="q_vehiculo"
                                disabled={soloConsulta}
                                onClickAdvanced={() => setVisibleBusquedaVehiculo(true)}
                                breakPoints={{
                                  xs: 24,
                                  sm: 24,
                                  md: 8,
                                }}
                                inputProps={{
                                  onPressEnter: () => searchVehiculo(),
                                  onChange: ({ target: { value } }) => {
                                    if (!value) {
                                      resetAndValidateVehiculo();
                                    }
                                  },
                                }}
                                resultProps={{
                                  name: 'padron_object_id',
                                  label: labelPadron,
                                  dataSource: vehiculoFound,
                                  render: (e) => padronToString(e, tipoDePadron),
                                  onClear: resetAndValidateVehiculo,
                                  rules: rules.required,
                                  breakPoints: {
                                    xs: 24,
                                    sm: 24,
                                    md: 8,
                                  },
                                }}
                              />
                            )}
                            {configDeInfraccion.aplica_serie && (
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  label="Serie"
                                  name="numero_de_serie"
                                >
                                  <Input
                                    disabled={!capturaDirecta || soloConsulta}
                                    maxLength={100}
                                    allowClear
                                  />
                                </Form.Item>
                              </Col>
                            )}
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Marca del Vehículo"
                                name="marca_del_vehiculo"
                              >
                                <Input
                                  disabled={!capturaDirecta || soloConsulta}
                                  allowClear
                                  maxLength={150}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Línea Vehícular"
                                name="linea_del_vehiculo"
                                normalize={toUpper}
                              >
                                <Input
                                  disabled={!capturaDirecta || soloConsulta}
                                  allowClear
                                  maxLength={150}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Color del Vehículo"
                                name="color_del_vehiculo"
                                normalize={toUpper}
                              >
                                <Input
                                  allowClear
                                  maxLength={150}
                                  disabled={soloConsulta}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <NumericInput
                                label="Modelo"
                                name="anio_de_modelo_vehicular"
                                disabled={!capturaDirecta || soloConsulta}
                              />
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Permiso de Tipo de Placa"
                                name="permiso_de_tipo_de_placa"
                              >
                                <Select disabled={soloConsulta} dataSource={permisoPlaca} />
                              </Form.Item>
                            </Col>
                            {permiso_de_tipo_de_placa === 1 && (
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  label="Número de Placa"
                                  name="numero_de_placa"
                                >
                                  <Input
                                    disabled={!capturaDirecta || soloConsulta}
                                    maxLength={100}
                                    allowClear
                                  />
                                </Form.Item>
                              </Col>
                            )}
                            {permiso_de_tipo_de_placa === 2 && (
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  label="Número de Permiso"
                                  name="numero_de_permiso"
                                  normalize={toUpper}
                                >
                                  <Input allowClear maxLength={100} disabled={soloConsulta} />
                                </Form.Item>
                              </Col>
                            )}
                            <Col xs={24} sm={24} md={8}>
                              <NumericInput
                                disabled={soloConsulta}
                                label={`Año de ${permisoPlaca
                                  .find((e) => e.id === permiso_de_tipo_de_placa)?.descripcion?.toLowerCase()}`}
                                name="anio_de_permiso_de_placa"
                              />
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Lugar de Expedición"
                                name="localidad_procedencia_vehiculo"
                              >
                                <Input allowClear maxLength={150} disabled={soloConsulta} />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Nombre de Propietario"
                                name="nombre_completo_propietario"
                              >
                                <Input
                                  disabled={!capturaDirecta || soloConsulta}
                                  maxLength={100}
                                  allowClear
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                label="Tipo de Servicio"
                                name="clase_de_servicio"
                              >
                                <Select disabled={soloConsulta} dataSource={claseDeServicio} />
                              </Form.Item>
                            </Col>

                            {clase_de_servicio && clase_de_servicio !== 1 && (
                              <>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    label="Número Económico"
                                    name="numero_economico"
                                  >
                                    <Input
                                      allowClear
                                      maxLength={150}
                                      disabled={soloConsulta}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <Form.Item
                                    label="Ruta de Servicio Público"
                                    name="ruta_servicio_publico"
                                  >
                                    <Select disabled={soloConsulta} dataSource={rutas} />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                            <Col xs={24} sm={24} md={16}>
                              <Form.Item
                                label="Observaciones del Vehículo"
                                name="observaciones_del_vehiculo"
                                normalize={toUpper}
                              >
                                <Input.TextArea
                                  autoSize={{ minRows: 3, maxRows: 3 }}
                                  allowClear
                                  disabled={soloConsulta}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane
                    tab={(
                      <>
                        <EnvironmentOutlined />
                        Datos de Infracción
                      </>
                      )}
                    key="datos"
                    forceRender
                  >
                    <Form
                      name="infractor"
                      layout="vertical"
                      form={formDatosInfra}
                      onFinish={() => onFinish()}
                      scrollToFirstError
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Agente"
                            name={configDeInfraccion.agente_usuario ? 'agente' : 'nombre_agente'}
                          >
                            {configDeInfraccion.agente_usuario ? (
                              <Select
                                disabled={soloConsulta}
                                dataSource={agente}
                                render={(e) => `${e?.nombre} ${e?.apellido_paterno}`}
                              />
                            ) : (<Input />)}
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Unidad/Patrulla"
                            name="unidad_policiaca"
                          >
                            <Select disabled={soloConsulta} dataSource={unidadPoliciaca} />
                          </Form.Item>
                        </Col>
                        {configDeInfraccion.aplica_sectores && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              label="Sector de Infracción"
                              name="sector_de_infraccion"
                            >
                              <Select disabled={soloConsulta} dataSource={sectorDeInfraccion} />
                            </Form.Item>
                          </Col>
                        )}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Tipo de Documento de Garantía"
                            name="tipo_de_documento_de_garantia"
                          >
                            <Select disabled={soloConsulta} dataSource={documentoDeGarantia} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Referencia del Documento"
                            name="referencia_del_documento"
                          >
                            <Input allowClear maxLength={100} disabled={soloConsulta} />
                          </Form.Item>
                        </Col>
                        {configDeInfraccion.aplica_fundamento_legal && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Fundamento Legal de Retiro"
                            name="fundamento_legal_retiro_vehiculo"
                          >
                            <Select
                              labelProp="denominacion"
                              dataSource={fundamentos}
                              disabled={soloConsulta}
                            />
                          </Form.Item>
                        </Col>
                        )}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Notificación de la infracción"
                            name="notificacion_infraccion"
                          >
                            <Select disabled={soloConsulta} dataSource={notificaciones} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Grúa"
                            name="grua"
                          >
                            <Select disabled={soloConsulta} dataSource={gruas} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Yarda"
                            name="yarda"
                          >
                            <Select disabled={soloConsulta} dataSource={yardas} />
                          </Form.Item>
                        </Col>
                        {!!selectedRowKeys.length && (
                          <Col xs={24} sm={24} md={8} style={{ alignSelf: 'center' }}>
                            <Button
                              onClick={handleImprimirActaDeInfraccion}
                              icon={<PrinterOutlined />}
                              loading={loading}
                              block
                            >
                              Imprimir Acta de Infracción
                            </Button>
                          </Col>
                        )}
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="comentarios_generales"
                            label="Comentarios Generales"
                            normalize={toUpper}
                          >
                            <Input.TextArea
                              disabled={soloConsulta}
                              autoSize={{ minRows: 3, maxRows: 3 }}
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            label="Lugar de Infracción"
                            name="lugar_de_infraccion"
                            normalize={capitalize}
                          >
                            <Input.TextArea
                              autoSize={{ minRows: 3, maxRows: 3 }}
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  {addressPermission?.view && (
                    <TabPane
                      tab={(
                        <>
                          <EnvironmentOutlined />
                          Dirección de Infracción
                        </>
                      )}
                      key="direccion_de_infraccion"
                      forceRender={!!selectedRowKeys?.length}
                      disabled={!selectedRowKeys.length}
                    >
                      <Direccion
                        mutable={!soloConsulta}
                        currentURI={baseURI}
                        parentID={selectedRowKeys[0]}
                        setLoading={setLoading}
                        setFormAddress={setFormAddress}
                        setCurrentTabKey={setCurrentTabKey}
                        addressPropName="direccion_de_infraccion"
                        callback={(values, _continue) => {
                          if (!_continue) {
                            onCancel();
                          } else {
                            const [key] = selectedRowKeys;
                            const clone = [...data?.results];
                            const mappedData = clone.map((e) => (e.id === key
                              ? ({ ...e, direccion_de_infraccion: values?.id }) : e));
                            setData(mappedData);
                          }
                        }}
                        permission={addressPermission}
                      />
                    </TabPane>
                  )}
                  {permission?.tabs?.conceptodeinfraccion?.view && (
                  <TabPane
                    tab={(
                      <>
                        <EnvironmentOutlined />
                        Conceptos de Infracciones
                      </>
                      )}
                    key="conceptos"
                    forceRender
                    disabled={!selectedRowKeys.length}
                  >
                    <TableTipoDeConceptos
                      infraccion={selectedRowKeys[0]}
                      permission={permission?.tabs?.conceptodeinfraccion}
                      changeStatus={(value) => {
                        form.setFieldsValue({ estado_de_la_infraccion: value });
                      }}
                      soloConsulta={soloConsulta}
                    />
                  </TabPane>
                  )}
                  {permission?.tabs?.archivodeinfraccion?.view && (
                    <TabPane
                      tab={(
                        <>
                          <CameraOutlined />
                          Evidencias
                        </>
                        )}
                      key="evidencias"
                      forceRender
                      disabled={!selectedRowKeys.length}
                    >
                      <EvidenciasDeInfracciones
                        infraccion={selectedRowKeys[0]}
                        permission={permission?.tabs?.archivodeinfraccion}
                        mutable={soloConsulta}
                      />
                    </TabPane>
                  )}
                </Tabs>
              </Card>
            </Col>
          )}
        {/* <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Infracción seleccionada"
          loading={loading}
          disabled={soloConsulta}
        /> */}
        { visibleCancelar && (
          <ModalCancelarInfraccion
            visible={visibleCancelar}
            setVisible={setVisibleCancelar}
            infraccionId={selectedRowKeys[0]}
            tipoDePadron={padronSelected}
            callback={fetchData}
          />
        )}
        <BusquedaAvanzadaPadrones
          visible={visibleBusquedaPadrones}
          setVisible={setVisibleBusquedaPadrones}
          callback={fetchCiudadano}
          tipoDePadron={1}
          allowAdd={false}
        />
        <BusquedaAvanzadaPadrones
          visible={visibleBusquedaContribuyente}
          setVisible={setVisibleBusquedaContribuyente}
          callback={fetchContribuyente}
          tipoDePadron={15}
          allowAdd={false}
        />
        <BusquedaAvanzadaPadrones
          visible={visibleBusquedaVehiculo}
          setVisible={setVisibleBusquedaVehiculo}
          callback={fetchVehiculo}
          tipoDePadron={tipoDePadron}
          allowAdd={false}
        />
        <Previewer
          visible={previewVisible}
          setVisible={setPreviewVisible}
          base64={base64}
        />
      </Spin>
    </Row>
  );
};

export default Infracciones;
